import axios, { AxiosError } from 'axios';
import { Environment } from '../../../environment';
import { Apicadastro } from '../axioscadastro';


export interface IListagemMunicipios {
  idmunicipio: string;
  uf: string;
  cidade: string;   
}

export interface IDetalheMunicipios {
  idmunicipio: string;
  uf: string;
  cidade: string;   
}


type TMunicipiosComTotalCount = {
    data: IListagemMunicipios[];
    totalCount: number;
}

interface ErrorResponse {
  error: {
    default: string;
  };
}


const getAlllist = async ( filter = '', id=''): Promise<TMunicipiosComTotalCount| Error> => {
  try {

    const urlRelativa: string = id === '' ? `/municipioslist?limit=${Environment.LIMITE_DE_CADASTRO}&filter=${filter}` : `/municipioslist/${id}` ;
    
    const { data, headers } = await Apicadastro.get(urlRelativa);

    if (data) {
      return {
        data,
        
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_CADASTRO),
      };
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {  
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};


const getAll = async (page = 1,  filter = '', id=''): Promise<TMunicipiosComTotalCount | Error> => {
  try {
    const urlRelativa = `/municipios?_page=${page}&_limit=${Environment.LIMITE_DE_CADASTRO}&filter=${filter}&id_like=${id}`;
    
    const { data, headers } = await Apicadastro.get(urlRelativa);

    if (data) {
      return {
        data,
        
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_CADASTRO),
      };
    }

    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {  
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};


const getById = async (id: string): Promise<IDetalheMunicipios | Error> => {
  try {
    const { data } = await Apicadastro.get(`/municipios/${id}`);

    if (data) {
      return data;
    }

    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {  
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const create = async (dados: IDetalheMunicipios): Promise<void | Error> => {
  try {
    const { data } = await Apicadastro.post<IDetalheMunicipios>('/municipios', dados);

    if (data) {
      return;
    }
  } catch (error) {
    if (axios.isAxiosError(error)) {  
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const updateById = async (id: string, dados: IDetalheMunicipios): Promise<void | Error> => {
  try {
    await Apicadastro.put(`/municipios/${id}`, dados);
  } catch (error) {
    if (axios.isAxiosError(error)) {  
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const deleteById = async (id: string): Promise<void | Error> => {
  try {
    await Apicadastro.delete(`/municipios/${id}`);
  } catch (error) {
    if (axios.isAxiosError(error)) {  
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};


export const MunicipiosService = {
  getAlllist,
  getAll,
  create,
  getById,
  updateById,
  deleteById,
};